import React from "react";
import ImagePostCarouselTag from "../../../GeneralPostTag/ImagePostCarouselTag";
import ImagePostTag from "../../../GeneralPostTag/ImagePostTag";
import VideoPostTag from "../../../GeneralPostTag/VideoPostTag";
import SeeMoreTile from "../../../../Screens/DashboardView/StayUpToDate/StayUpToDateComponents/StructureTemplates/SeeMoreTile";
import ImagePostTagLocal from "../../../GeneralPostTag/ImagePostTagLocal";

const FrontendTemplate = (props: any) => {
  const {
    param,
    containerRef,
    isMobile,
    data,
    handleRedirect,
    brand_color,
    isLinks,

    type,

    title,
    component,
    user_id,
    username,
    total_count,
    from
  } = props;
  return (
    <div
      className={!param?.id ? "outer-container-reels" : ""}
      ref={containerRef}
    >
      <div
        className={
          !param?.id
            ? "links-grid-container-reels"
            : isMobile
              ? "item-grid creator-card-grid-wrp"
              : "item-grid"
        }
      >
        {data &&
          data.slice(0, 25).map((link: any, index: number) => {
            return (
              <div
                key={index}
                className={
                  link.platform != "youtube"
                    ? "link-url"
                    : !link.product_image
                      ? "link-url youtube-link-position"
                      : "link-url"
                }
              >
                {
                  link?.platform == "podcast" ? (<>
                    <div className="creator-feed-image-wrapper-pod" style={{ width: "auto" }}>
                      <ImagePostTagLocal
                        key={link.id}
                        data={link}
                        isPodcast={link?.platform == "podcast"}
                        brand_color={brand_color}
                        content_shape={component?.content_shape}
                        isYoutube={false}
                      />
                    </div>
                  </>) :
                    link.media_url ? (
                      link.media_url.split(",").length > 1 &&
                        link.media_url
                          .split(",")
                          .every((url: any) => url.trim() !== "") ? (
                        <>
                          <ImagePostCarouselTag
                            post={link}
                            handleRedirect={handleRedirect}
                            brand_color={brand_color}
                            isLinks={isLinks}
                            isDashboard={false}
                            isHasMediaUrl={
                              link.type === "FEED" &&
                                link.platform !== "MISC-content"
                                ? true
                                : false
                            }
                            isYoutube={
                              link.platform == "youtube" && !link.product_image
                                ? true
                                : false
                            }
                            contentShape={
                              component?.content_shape
                            }
                            isSoundOn={component?.content_sound}
                            from={from}
                          />
                        </>
                      ) : (
                        <>
                          {link.product_image && link.product_image !== "" ? (
                            <>
                              <ImagePostTag
                                data={link}
                                handleRedirect={handleRedirect}
                                title={title}
                                brand_color={brand_color}
                                isLinks={isLinks}
                                isDashboard={false}
                                isHasMediaUrl={
                                  link.type === "FEED" &&
                                    link.platform !== "MISC-content"
                                    ? true
                                    : false
                                }
                                isYoutube={
                                  link.platform == "youtube" && !link.product_image
                                    ? true
                                    : false
                                }
                                contentShape={
                                  component?.content_shape
                                }
                                from={from}
                              // isSoundOn={component?.content_sound}
                              // isSoundOn={component?.content_sound}
                              />
                            </>
                          ) : (
                            <>
                              {link.media_url.includes("video") ? (
                                <>
                                  <VideoPostTag
                                    post={link}
                                    handleRedirect={handleRedirect}
                                    title={title}
                                    brand_color={brand_color}
                                    isLinks={isLinks}
                                    isDashboard={false}
                                    thumbnail={link.thumbnail}
                                    isHasMediaUrl={
                                      link.type === "FEED" &&
                                        link.platform !== "MISC-content"
                                        ? true
                                        : false
                                    }
                                    isYoutube={
                                      link.platform == "youtube" &&
                                        !link.product_image
                                        ? true
                                        : false
                                    }
                                    type={type}
                                    contentShape={
                                      component?.content_shape
                                    }
                                    isSoundOn={component?.content_sound}
                                    from={from}
                                  />
                                </>
                              ) : (
                                <>
                                  <ImagePostTag
                                    data={link}
                                    handleRedirect={handleRedirect}
                                    title={title}
                                    brand_color={brand_color}
                                    isLinks={isLinks}
                                    isDashboard={false}
                                    isHasMediaUrl={
                                      link.type === "FEED" &&
                                        link.platform !== "MISC-content"
                                        ? true
                                        : false
                                    }
                                    isYoutube={
                                      link.platform == "youtube" &&
                                        !link.product_image
                                        ? true
                                        : false
                                    }
                                    contentShape={
                                      component?.content_shape
                                    }
                                    from={from}
                                  // isSoundOn={component?.content_sound}
                                  // isSoundOn={component?.content_sound}
                                  />
                                </>
                              )}
                            </>
                          )}
                        </>
                      )
                    ) : (
                      <>
                        <ImagePostTag
                          data={link}
                          handleRedirect={handleRedirect}
                          title={title}
                          brand_color={brand_color}
                          isLinks={isLinks}
                          isDashboard={false}
                          isHasMediaUrl={
                            link.type === "FEED" && link.platform !== "MISC-content"
                              ? true
                              : false
                          }
                          isYoutube={
                            link.platform == "youtube" && !link.product_image
                              ? true
                              : false
                          }
                          contentShape={
                            component?.content_shape
                          }
                          from={from}
                        // isSoundOn={component?.content_sound}
                        // isSoundOn={component?.content_sound}
                        />
                      </>
                    )}{" "}
              </div>
            );
          })}

        <SeeMoreTile
          data={data}
          total_count={total_count}
          type={type}
          unique_id={component?.route_name || component?.unique_id}
          user_id={user_id}
          username={username}
          component={component}
          from={from}
        />
      </div>
    </div>
  );
};

export default FrontendTemplate;
